const STRINGS = {
	accepts: gettext('Accepts'),
	fileUploaded: gettext('The file has been uploaded.'),
	fileUploadError: gettext('An error has occurred.'),
	chooseFile: gettext('Choose File'),
	removed: gettext('The file has been removed.'),
	success: gettext('Success'),
	error: gettext('Error'),
	invalid_type: gettext('Invalid file type.'),
	labels: {
		replace: gettext('Replace image'),
		remove: gettext('Remove image'),
	},
};

module.exports = STRINGS;
